<mat-icon class="prefix">search</mat-icon>
<input (click)="checkClick()" (keyup)="search($event)" [(ngModel)]="searchQuery" type="text"/>
